export const config = {
  title: "Amaury Cleaning Services",
  meta: {
    description:
      "Amaury Cleaning Services offers professional office and commercial cleaning solutions in Allentown, PA. Our meticulous services ensure a spotless environment for your business.",
    keywords: [
      "Commercial Cleaning Allentown",
      "Office Cleaning Services",
      "Deep Cleaning",
      "Amaury Cleaning Services",
    ],
    author: "Amaury Cleaning Services",
    canonicalUrl: "https://www.amaurycleaningservice.com/",
  },
  sections: {
    header: {
      businessName: "Amaury Cleaning Services",
    },
    sectionB: {
      heroTitle: "Amaury Cleaning Services",
      heroSubtitle: "Professional Cleaning Solutions in Allentown, PA",
      learnAboutText: "Discover Our Services",
      phoneNumber: "4849357575",
      phoneLabel: "(484) 935-7575",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2159352827/photo/in-the-home-renovation-site-worker-using-products-for-mold-remediation-treatment-wearing-a.jpg?s=612x612&w=0&k=20&c=4moQ0KJDXKJTTqYvvZJSfr0zlIrn_o5DAf2knBJf5KM=",
      cardData: [
        {
          title: "Office Cleaning",
          description:
            "Tailored cleaning services to maintain a clean and organized office environment.",
        },
        {
          title: "Commercial Cleaning",
          description:
            "Comprehensive cleaning solutions for commercial properties to ensure a welcoming space.",
        },
        {
          title: "Deep Cleaning",
          description:
            "Thorough cleaning services to eliminate dirt, grime, and germs from every corner.",
        },
      ],
      description:
        "At Amaury Cleaning Services, we specialize in providing top-notch office and commercial cleaning solutions. Our commitment to excellence ensures cleaner and healthier spaces for our clients.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Explore the range of cleaning services we offer to meet your business needs.",
      cards: [
        {
          title: "Office Cleaning",
          description:
            "Maintain a productive workspace with our detailed office cleaning services.",
          imageSrc: "https://media.istockphoto.com/id/2083149099/photo/female-housekeeper-smile-and-wearing-glove-preparing-to-clean-office.jpg?s=612x612&w=0&k=20&c=gq1FMwy4h8Jb-HpxTlPcjt0fFWDCba_PlnSkSakh33o=",
          imageAlt: "Office Cleaning",
        },
        {
          title: "Commercial Cleaning",
          description:
            "Ensure a professional appearance with our comprehensive commercial cleaning solutions.",
          imageSrc: "https://media.istockphoto.com/id/1316473356/photo/an-employee-pulls-a-trolley-for-cleaning-offices-woman-cleaner-is-engaged-in-work.jpg?s=612x612&w=0&k=20&c=6QWgeQ8HQU4TvT4lu9l2hBLiKUVYLcF_6-deEMn-vb8=",
          imageAlt: "Commercial Cleaning",
        },
        {
          title: "Deep Cleaning",
          description:
            "Achieve a hygienic environment with our thorough deep cleaning services.",
          imageSrc: "https://media.istockphoto.com/id/1296078534/photo/janitor-vacuum-cleaning-the-corridor-of-an-office-building.jpg?s=612x612&w=0&k=20&c=IHvobJ6kUWxJYEdOdm_wL0ARXd9vMCvi4jIg3Pq3OHw=",
          imageAlt: "Deep Cleaning",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Janitorial Services",
        "Move-In/Move-Out Cleaning",
        "Post-Construction Cleaning",
        "Window Cleaning",
        "Floor Care",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://static.wixstatic.com/media/72c334_328ddc5980b04da8ac7a756ae553e9da~mv2.jpg",
        alt: "Amaury Cleaning Services Team",
      },
      aboutText: [
        "Amaury Cleaning Services is dedicated to providing reliable, detail-oriented cleaning services tailored to meet your needs.",
        "With a commitment to excellence, we strive to create cleaner and healthier spaces for our clients. Our dedication to quality service sets us apart in the cleaning industry.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Amaury Cleaning Services Logo",
      businessName: "Amaury Cleaning Services",
      contact: {
        phone: "4849357575",
        phoneLabel: "(484) 935-7575",
        email: "amaurypolaco@yahoo.com",
        website: "https://www.amaurycleaningservice.com/",
        address: "1635 Greenleaf St, Allentown, PA 18102, USA",
      },
      socialMedia: {
        facebook: null,
        twitter: null,
        instagram: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "1635 Greenleaf St, Allentown, PA 18102, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.123456789012!2d-75.1234567!3d40.1234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6c1234567890%3A0xabcdef1234567890!2s1635%20Greenleaf%20St%2C%20Allentown%2C%20PA%2018102!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus",
    },
  },
};

export default config;
